module.exports = __webpack_public_path__ + "static/img/ves.1d80dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/ves.png
// module id = 1SN1
// module chunks = 0